import { render, staticRenderFns } from "./feeVouchersReportComponent.vue?vue&type=template&id=24d53a2a&"
import script from "./feeVouchersReportComponent.vue?vue&type=script&lang=js&"
export * from "./feeVouchersReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports